import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b5f15aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "content-confirmation-page",
  class: "mb-8"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title-2" }, "下記の内容で予約を確定します", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ご希望の日時は、既に他の予約で埋まっております。", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "再度、日時選択ボタンより、ご希望日時をお選びください。", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "row first-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "氏名", -1))
const _hoisted_9 = { class: "value-text" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "電話番号", -1))
const _hoisted_12 = { class: "value-text" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "メールアドレス", -1))
const _hoisted_15 = { class: "value-text" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "生年月日", -1))
const _hoisted_18 = { class: "value-text" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "住所（郵便番号）", -1))
const _hoisted_21 = { class: "value-text" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "住所（都道府県・市区町村・丁目）", -1))
const _hoisted_24 = { class: "value-text" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "住所（番地・建物）", -1))
const _hoisted_27 = { class: "value-text" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "性別", -1))
const _hoisted_30 = { class: "value-text" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title first-row" }, "お子様の情報", -1))
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "氏名", -1))
const _hoisted_34 = { class: "value-text" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "氏名（かな）", -1))
const _hoisted_37 = { class: "value-text" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "性別", -1))
const _hoisted_40 = { class: "value-text" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "生年月日", -1))
const _hoisted_43 = { class: "value-text" }
const _hoisted_44 = {
  key: 0,
  class: "row"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "お店に伝えたいこと", -1))
const _hoisted_46 = { class: "value-text" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "保護者の情報", -1))
const _hoisted_48 = { class: "row" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "氏名", -1))
const _hoisted_50 = { class: "value-text" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "メールアドレス", -1))
const _hoisted_53 = { class: "value-text" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "電話番号", -1))
const _hoisted_56 = { class: "value-text" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "住所（郵便番号）", -1))
const _hoisted_59 = { class: "value-text" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "住所（都道府県・市区町村・丁目）", -1))
const _hoisted_62 = { class: "value-text" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "住所（番地・建物）", -1))
const _hoisted_65 = { class: "value-text" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "生年月日", -1))
const _hoisted_68 = { class: "value-text" }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "性別", -1))
const _hoisted_71 = { class: "value-text" }
const _hoisted_72 = { key: 3 }
const _hoisted_73 = { class: "text-3" }
const _hoisted_74 = { class: "value-text" }
const _hoisted_75 = {
  key: 4,
  class: "row"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "予約日時", -1))
const _hoisted_77 = { class: "value-text" }
const _hoisted_78 = {
  key: 5,
  class: "row"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "リクエスト予約日時", -1))
const _hoisted_80 = {
  key: 0,
  class: "value-text"
}
const _hoisted_81 = {
  key: 1,
  class: "value-text"
}
const _hoisted_82 = {
  key: 2,
  class: "value-text"
}
const _hoisted_83 = { class: "row" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "所要時間目安", -1))
const _hoisted_85 = { class: "value-text" }
const _hoisted_86 = {
  key: 6,
  class: "row"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "気になる部位・お悩みの症状", -1))
const _hoisted_88 = { class: "value-text" }
const _hoisted_89 = {
  key: 7,
  class: "row"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "その他・伝達事項", -1))
const _hoisted_91 = { class: "value-text" }
const _hoisted_92 = { class: "controller-wrapper" }

import { useStore } from "vuex"; // Vuexストアへのアクセス
import { onBeforeMount, ref, computed } from "vue"; // Composition API
import moment from "moment"; // 日付操作ライブラリ
import Message from "primevue/message"; // エラーメッセージ表示用コンポーネント（template側用）
import RouterUtils from "@/common/utils/router.util"; // ページ遷移ユーティリティ
import RouterConstants from "../constants/router.constants"; // 遷移先ルート定数
import ValidateBookingSteps from "../validates/validate.booking.steps"; // ステップバリデーション
import DateTimeUtils from "@/customer/utils/date-time-utils"; // 日時整形ユーティリティ（template側使用想定）
import type { IWorryContent, IWorryTag } from "../typings"; // 悩みコンテンツ型定義

/* ストアの取得 */

export default /*#__PURE__*/_defineComponent({
  __name: 'ContentConfirmation',
  setup(__props) {

/**
 * 予約確認画面のロジック
 *
 * - 顧客の選択情報をVuexから取得し、確認画面として整形表示
 * - 「戻る」「カレンダーに戻る」「予約確定」ボタンに応じた画面遷移処理を定義
 * - APIエラー時にはエラー内容に応じた分岐処理（例：OTP入力画面へ遷移）
 *
 * 使用技術：
 * - Vue 3 Composition API + <script setup>
 * - Vuex（状態取得・更新）
 * - PrimeVue（エラー表示など）
 * - moment.js（日付整形）
 */

const store = useStore();

/**
 * 現在選択中の予約種別（通常 or リクエスト）をVuexから取得
 * @type {Ref<string>}
 */
const bookingType = ref(store.getters["booking/selectedMenu"]?.bookingType);

/**
 * APIエラー発生時に、エラー内容を格納するオブジェクト
 * @type {Ref<Object>}
 */
const errorsObject = ref<{
  step?: string;
  message?: string;
}>({});

/**
 * 選択された悩みタグのIDリスト
 */
const selectedWorryTags = computed(() => {
  return store.getters["booking/customerInfo"].selectedWorryTags || [];
});

/**
 * 悩みコンテンツリスト
 */
const worryContents = computed(() => {
  return store.getters["booking/worryContents"] || [];
});

/**
 * 選択されたタグがある悩みコンテンツのみをフィルタリング
 */
const worryContentsWithSelectedTags = computed(() => {
  return worryContents.value.filter((content: IWorryContent) => {
    return content.worry_tags.some(tag => selectedWorryTags.value.includes(tag.id));
  });
});

/**
 * 指定されたコンテンツで選択されたタグのみを取得
 */
const getSelectedTagsForContent = (content: IWorryContent) => {
  return content.worry_tags.filter(tag => selectedWorryTags.value.includes(tag.id));
};

/**
 * 子ども予約フラグを取得
 */
const isChildBooking = computed(() => {
  return store.getters["booking/isChildBooking"];
});

/**
 * お子様情報を取得
 */
const childInfo = computed(() => {
  return store.getters["booking/childInfo"] || {};
});

/**
 * 保護者情報を取得
 */
const parentInfo = computed(() => {
  return store.getters["booking/parentInfo"] || {};
});

/**
 * 性別を日本語表記（男／女性／その他）で返す
 *
 * @function genderFormat
 * @returns {string}
 */
const genderFormat = computed(() => {
  const gender = isChildBooking.value ? childInfo.value.gender : store.getters["booking/customerInfo"].gender;
  switch (gender) {
    case "male":
      return "男";
    case "female":
      return "女性";
    default:
      return "その他";
  }
});

/**
 * 保護者の性別を日本語表記で返す
 */
const parentGenderFormat = computed(() => {
  switch (parentInfo.value.gender) {
    case "male":
      return "男";
    case "female":
      return "女性";
    default:
      return "その他";
  }
});

/**
 * 「戻る」ボタン押下時の処理
 * - 子ども予約の場合は子ども情報入力画面に戻る
 * - 通常予約の場合は個人情報入力画面に戻る
 *
 * @function back
 * @returns {void}
 */
const back = () => {
  if (isChildBooking.value) {
    RouterUtils.goTo(RouterConstants.CHILD_BOOKING_INFO_ROUTER_NAME);
  } else {
    RouterUtils.goTo(RouterConstants.PERSONAL_INFO_ROUTER_NAME);
  }
};

/**
 * 「カレンダーに戻る」処理
 * - 選択された時間をリセットし、予約カレンダーへ遷移
 *
 * @function handleBackToCalendar
 * @returns {void}
 */
const handleBackToCalendar = () => {
  store.commit("booking/resetSelectedTime");
  RouterUtils.goTo(RouterConstants.BOOKING_CALENDAR_ROUTER_NAME);
};

/**
 * 予約確定ボタンの送信中フラグ
 *
 * - trueの場合はリクエスト送信中とみなし、ボタンの連打による多重送信を防止する
 * - falseに戻すのは、リクエスト成功時または失敗時
 */
const submitting = ref(false);

/**
 * 「予約確定」ボタン押下時の処理
 *
 * - submittingフラグでリクエスト多重送信を防止する
 * - booking/submitBooking をdispatchし、成功時は予約完了画面へ遷移
 * - エラーが返却された場合はエラーオブジェクトに格納
 * - 特定のエラー(step === 'account') の場合はOTP入力画面へ遷移
 *
 * @function accept
 * @returns {void}
 */
const accept = () => {
  if (submitting.value) return; // すでに送信中なら二重送信を防止して抜ける
  submitting.value = true; // 最初の送信時に送信中フラグを立て、以降のリクエストをブロックする

  // LIFF（顧客側）では自由予約を使用しないため、明示的にfalseを設定
  store.commit("booking/setIsFreeSpace", false);

  store.dispatch("booking/submitBooking", {
    /**
     * API成功時のコールバック
     *
     * @function success
     * @returns {void}
     */
    success: () => {
      submitting.value = false; // 成功時は送信中フラグを解除する
      store.commit("booking/setEditFlag", false);
      RouterUtils.goTo(RouterConstants.BOOKING_SUCCESS_ROUTER_NAME);
    },

    /**
     * API失敗時のコールバック
     *
     * @function error
     * @param {Object} error - Axiosレスポンスエラーオブジェクト
     * @returns {void}
     */
    error: (error: { response: { data: { errors: { step?: string; message?: string } } } }) => {
      submitting.value = false; // エラー時も送信中フラグを解除して再送信を可能にする
      errorsObject.value = error.response.data.errors;

      // step="account" の場合はOTP画面へ強制遷移
      if (errorsObject.value.step == "account") {
        RouterUtils.goTo(RouterConstants.OTP_FORM_NAME);
      }
    },
  });
};

/**
 * マウント前処理：ステップバリデーションを実行
 *
 * @function onBeforeMount
 * @returns {void}
 */
onBeforeMount(() => {
  ValidateBookingSteps();
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (errorsObject.value.step)
      ? (_openBlock(), _createBlock(_unref(Message), {
          key: 0,
          class: "errors mb-5",
          severity: "error",
          closable: false
        }, {
          default: _withCtx(() => [
            (errorsObject.value.step == 'booking_time')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_3,
                  _hoisted_4
                ], 64))
              : (errorsObject.value.step == 'partner')
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "エラーが発生しました。詳細についてはクリニックにお問い合わせください。"))
                : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(errorsObject.value.message), 1))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_unref(isChildBooking))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(store).getters["booking/customerInfo"].lastName) + " " + _toDisplayString(_unref(store).getters["booking/customerInfo"].firstName), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(store).getters["booking/customerInfo"].tel), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(store).getters["booking/customerInfo"].email), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(moment)(_unref(store).getters["booking/customerInfo"].birthday).format("YYYY年MM月DD日")), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(store).getters["booking/customerInfo"].zipcode), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(store).getters["booking/customerInfo"].address), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(store).getters["booking/customerInfo"].addressNumber), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("p", _hoisted_30, _toDisplayString(_unref(genderFormat)), 1)
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_unref(isChildBooking))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("p", _hoisted_34, _toDisplayString(_unref(childInfo).lastName) + " " + _toDisplayString(_unref(childInfo).firstName), 1)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("p", _hoisted_37, _toDisplayString(_unref(childInfo).lastNameKana) + " " + _toDisplayString(_unref(childInfo).firstNameKana), 1)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("p", _hoisted_40, _toDisplayString(_unref(genderFormat)), 1)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("p", _hoisted_43, _toDisplayString(_unref(moment)(_unref(childInfo).birthday).format("YYYY年MM月DD日")), 1)
          ]),
          (_unref(childInfo).noteSymptom)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("p", _hoisted_46, _toDisplayString(_unref(childInfo).noteSymptom), 1)
              ]))
            : _createCommentVNode("", true),
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("p", _hoisted_50, _toDisplayString(_unref(parentInfo).lastName) + " " + _toDisplayString(_unref(parentInfo).firstName), 1)
          ]),
          _createElementVNode("div", _hoisted_51, [
            _hoisted_52,
            _createElementVNode("p", _hoisted_53, _toDisplayString(_unref(parentInfo).email), 1)
          ]),
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("p", _hoisted_56, _toDisplayString(_unref(parentInfo).tel), 1)
          ]),
          _createElementVNode("div", _hoisted_57, [
            _hoisted_58,
            _createElementVNode("p", _hoisted_59, _toDisplayString(_unref(parentInfo).zipcode), 1)
          ]),
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _createElementVNode("p", _hoisted_62, _toDisplayString(_unref(parentInfo).address), 1)
          ]),
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            _createElementVNode("p", _hoisted_65, _toDisplayString(_unref(parentInfo).addressNumber), 1)
          ]),
          _createElementVNode("div", _hoisted_66, [
            _hoisted_67,
            _createElementVNode("p", _hoisted_68, _toDisplayString(_unref(moment)(_unref(parentInfo).birthday).format("YYYY年MM月DD日")), 1)
          ]),
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            _createElementVNode("p", _hoisted_71, _toDisplayString(_unref(parentGenderFormat)), 1)
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_unref(selectedWorryTags).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(worryContentsWithSelectedTags), (content) => {
            return (_openBlock(), _createElementBlock("div", {
              key: content.id,
              class: "row worry-content-row"
            }, [
              _createElementVNode("h3", _hoisted_73, _toDisplayString(content.name), 1),
              _createElementVNode("p", _hoisted_74, _toDisplayString(getSelectedTagsForContent(content)
              .map((tag) => tag.name)
              .join(" ")), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (bookingType.value != 'request')
      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
          _hoisted_76,
          _createElementVNode("p", _hoisted_77, _toDisplayString(_unref(moment)(`${_unref(store).getters["booking/selectedTime"].date} ${_unref(store).getters["booking/selectedTime"].time}`).format(
            "YYYY年MM月DD日 HH:mm"
          )), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_78, [
          _hoisted_79,
          (_unref(store).getters['booking/selectedRequestDates']?.first)
            ? (_openBlock(), _createElementBlock("p", _hoisted_80, " 第一希望：" + _toDisplayString(_unref(moment)(_unref(store).getters["booking/selectedRequestDates"]?.first).format("YYYY年MM月DD日 HH:mm")), 1))
            : _createCommentVNode("", true),
          (_unref(store).getters['booking/selectedRequestDates']?.second)
            ? (_openBlock(), _createElementBlock("p", _hoisted_81, " 第二希望：" + _toDisplayString(_unref(moment)(_unref(store).getters["booking/selectedRequestDates"]?.second).format("YYYY年MM月DD日 HH:mm")), 1))
            : _createCommentVNode("", true),
          (_unref(store).getters['booking/selectedRequestDates']?.third)
            ? (_openBlock(), _createElementBlock("p", _hoisted_82, " 第三希望：" + _toDisplayString(_unref(moment)(_unref(store).getters["booking/selectedRequestDates"]?.third).format("YYYY年MM月DD日 HH:mm")), 1))
            : _createCommentVNode("", true)
        ])),
    _createElementVNode("div", _hoisted_83, [
      _hoisted_84,
      _createElementVNode("p", _hoisted_85, _toDisplayString(_unref(DateTimeUtils).convertMinutesToHoursAndMinutes(_unref(store).getters["booking/totalTime"])), 1)
    ]),
    (_unref(store).getters['booking/customerInfo'].noteSymptom)
      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
          _hoisted_87,
          _createElementVNode("p", _hoisted_88, _toDisplayString(_unref(store).getters["booking/customerInfo"].noteSymptom), 1)
        ]))
      : _createCommentVNode("", true),
    (_unref(store).getters['booking/customerInfo'].note)
      ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
          _hoisted_90,
          _createElementVNode("p", _hoisted_91, _toDisplayString(_unref(store).getters["booking/customerInfo"].note), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_92, [
      _createVNode(_component_Button, {
        class: "btn cancel-btn w-full",
        onClick: back
      }, {
        default: _withCtx(() => [
          _createTextVNode("戻る")
        ]),
        _: 1
      }),
      (errorsObject.value.step && errorsObject.value.step == 'booking_time')
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "btn accept-btn w-full",
            onClick: handleBackToCalendar
          }, {
            default: _withCtx(() => [
              _createTextVNode("日時選択")
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            class: "btn accept-btn w-full",
            onClick: accept
          }, {
            default: _withCtx(() => [
              _createTextVNode("予約確定")
            ]),
            _: 1
          }))
    ])
  ]))
}
}

})